import * as React from 'react'
import { cn } from '@/lib/utils'

/** A styled text input that forwards its ref and all native input props. */
export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(function Input({ className, type, ...props }, ref) {
  return (
    <input
      type={type}
      className={cn(
        // 32px tall, flat (no shadow), and no per-component focus ring — the
        // global `:focus-visible` rule in index.css supplies the design
        // system's quiet brand border + halo. 13px text here, but below `lg`
        // index.css lifts every field to 16px so iOS does not zoom in on focus.
        'flex h-8 w-full rounded-md border border-default bg-surface px-2.5 text-sm text-primary-text transition-colors placeholder:text-disabled-text hover:border-strong focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-subtle disabled:opacity-60',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
